module.exports = __webpack_public_path__ + "img/erweima3.32217442.png";